import { motion } from 'framer-motion';
import { CheckCircle, Briefcase, Building2, Shield } from 'lucide-react';

const cards = [
  { icon: CheckCircle, title: 'Sistema en uso real', desc: 'Basado en una plataforma que ya opera en un estudio jurídico activo.' },
  { icon: Briefcase, title: 'Gestión completa del despacho', desc: 'Causas, clientes, documentos, agenda, tareas y equipo en un solo lugar.' },
  { icon: Building2, title: 'Separación por organización', desc: 'Cada estudio trabaja con sus propios datos, usuarios y configuraciones.' },
  { icon: Shield, title: 'Acceso inmediato luego del registro', desc: 'Creá tu cuenta y comenzá a usar el sistema en minutos.' },
];

export default function SystemProvenSection() {
  return (
    <section id="sistema" className="relative py-20 lg:py-28 bg-[#080808]" data-testid="system-proven-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="text-center mb-14">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-[#F8F6F0] tracking-tight mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            No empezás desde cero. <span className="text-[#C9A44C] italic">Usás una plataforma ya probada.</span>
          </h2>
          <p className="text-[#B8B8B8] text-sm sm:text-[15px] max-w-2xl mx-auto leading-relaxed">
            LexOrbit se basa en un sistema de gestión jurídica que ya se encuentra operativo en un estudio jurídico real. Ahora fue adaptado como SaaS multitenant para que cada abogado o estudio pueda crear su propia organización y trabajar en un entorno independiente.
          </p>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="bg-[#141414] border border-[rgba(201,164,76,0.15)] rounded-xl p-6 hover:border-[rgba(201,164,76,0.35)] hover:-translate-y-0.5 transition-all duration-400"
                data-testid={`proven-card-${i}`}>
                <Icon className="w-5 h-5 text-[#C9A44C] mb-3" strokeWidth={1.5} />
                <h3 className="text-[#F8F6F0] text-sm font-semibold mb-2">{c.title}</h3>
                <p className="text-[#B8B8B8] text-xs leading-relaxed">{c.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
